import React from 'react';
import { Box, Typography, Button, Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CheckCircleOutlineTwoTone, DoneAll, MarkEmailRead } from '@mui/icons-material';

const EmailSentSuccess = ({ onResend }) => {
    const { t } = useTranslation();

    return (
        <Box sx={{ textAlign: 'center', maxWidth: 500, mx: 'auto', mt: 4 }}>
            <Alert icon={false} severity="success" sx={{ alignItems: 'center', flexDirection: 'column', mb: 3 }}>
                <CheckCircleOutlineTwoTone fontSize="large" />
                <Typography variant="h3" fontWeight="bold">
                    {t('EmailSentSuccessTitle')}
                </Typography>
                <Typography sx={{ fontSize: '17px' }}>{t('EmailSentSuccessDescription')}</Typography>
            </Alert>

            <Typography sx={{ mb: 2 }}>{t('EmailSentSuccessHint')}</Typography>

            <Button variant="contained" color="primary" onClick={onResend}>
                {t('RefillForm')}
            </Button>
        </Box>
    );
};

export default EmailSentSuccess;
